import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const updateSubject = createAsyncThunk('updateSubject', async (data) => {

    try {
        const res = await axios({

            method: 'PUT',
            url: getConfig.API_URL + `subject`,
            data: {
                "id": data?.values?.id,
                "subject_name": data?.values?.subject_name,
                "subject_code": data?.values?.subject_code,
                "subject_type": data?.values?.subject_type,
                "description": data?.values?.description,
                "status": data?.values?.status
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})
